import { sendWaitlistForm } from '../../actions/waitlist/actions';

export function mapStateToProps() {
  return {
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    sendWaitlistForm: (params) => dispatch(sendWaitlistForm(params)),
  };
}
